import { render, staticRenderFns } from "./ModalTabs.vue?vue&type=template&id=642e3327&"
import script from "./ModalTabs.vue?vue&type=script&lang=ts&"
export * from "./ModalTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports